/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById("Search-Drawer");
    this.form = this.container.querySelector("form.searchform");
    this.button = document.querySelectorAll(".thb-quick-search");
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector(
      ".side-panel-content--initial"
    );
    this.predictiveSearchResults = this.container.querySelector(
      ".side-panel-content--has-tabs"
    );

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.button.forEach((item, i) => {
      item.addEventListener("click", (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle("open-cc");
        this.container.classList.toggle("active");
        if (this.container.classList.contains("active")) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true,
            });
          }, 100);
          dispatchCustomEvent("search:open");
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove("active");
      return;
    }
    this.predictiveSearchResults.classList.add("active");
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add("loading");

    fetch(
      `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&${encodeURIComponent(
        "resources[type]"
      )}=product,article,query&${encodeURIComponent(
        "resources[limit]"
      )}=10&section_id=predictive-search`
    )
      .then((response) => {
        this.predictiveSearchResults.classList.remove("loading");
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector("#search-results-submit");

    submitButton.addEventListener("click", () => {
      _this.form.submit();
    });
  }

  close() {
    this.container.classList.remove("active");
  }
}
/* CLAUDE 2026-10-16 (Kei: "fix the search icon opening an empty page if clicked before the page finishes loading").
   Was: new PredictiveSearch() only on window "load" (every image and app loaded), so an earlier click on the header search icon
   followed its plain link to the empty /search page. Now, when snippets/claude-search-early-click.liquid switches it on, it starts
   at DOMContentLoaded (app.js with debounce/dispatchCustomEvent has run by then) and opens the panel for a click that snippet held
   back. "load" stays as a fallback start. Script: Temp/search-icon-early-fix-2026-10-16.js */
(function () {
  function claudeInitSearch() {
    if (window.__claudeSearchReady || typeof PredictiveSearch === "undefined") return;
    try { new PredictiveSearch(); } catch (e) { return; }
    window.__claudeSearchReady = true;
    if (window.__claudeSearchPending) {
      window.__claudeSearchPending = false;
      var b = document.querySelector(".thb-quick-search");
      if (b) b.click();
    }
  }
  if (window.__claudeSearchFix === true) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", claudeInitSearch);
    else claudeInitSearch();
  }
  window.addEventListener("load", claudeInitSearch);
})();
